module.exports = __webpack_public_path__ + "static/labs-7e92825d9be4e048f66e76030c4a6b32.png";